import React from "react";
import logo from "../assets/logo.jpeg";

const Hero = () => {
  return (
    <section
      id="home"
      className="relative min-h-screen flex items-center bg-black text-white overflow-hidden"
    >
      {/* Grid Background Pattern */}
      <div 
        className="absolute inset-0 opacity-5"
        style={{
          backgroundImage: 'linear-gradient(90deg, white 1px, transparent 1px), linear-gradient(white 1px, transparent 1px)',
          backgroundSize: '50px 50px'
        }}
      ></div>

      <div className="max-w-7xl mx-auto px-8 relative z-10 w-full">
        <div className="grid lg:grid-cols-2 gap-20 items-center">
          
          {/* Left Content */}
          <div>
            {/* Eyebrow with borders */}
            <div className="mb-8 border-t border-b border-white py-4 inline-block">
              <span className="text-xs font-sans tracking-widest uppercase font-light text-gray-300">
                Registered Legal & Social Welfare Organization
              </span>
            </div>

            {/* Main Headline - Bold Serif */}
            <h1 className="text-7xl md:text-8xl font-black leading-none mb-8 tracking-tight" style={{fontFamily: 'Georgia, serif'}}>
              LEGAL<br />
              <span className="inline-block">LIONS</span>
            </h1>

            {/* Tagline */}
            <p className="text-xl md:text-2xl font-sans font-light mb-12 leading-relaxed max-w-lg text-gray-200">
              Empowering citizens through legal awareness, social welfare, community support, and access to justice for everyone.
            </p>

            {/* CTA Buttons */}
            <div className="flex flex-col sm:flex-row gap-4 mb-16">
              <button className="bg-white text-black px-8 py-4 font-sans font-bold text-sm hover:bg-gray-200 transition flex items-center justify-center gap-2 group">
                Get Legal Assistance
                <span className="group-hover:translate-x-1 transition">→</span>
              </button>

              <button className="border-2 border-white text-white px-8 py-4 font-sans font-bold text-sm hover:bg-white hover:text-black transition">
                Become a Member
              </button>
            </div>

            {/* Stats Grid */}
            <div className="grid grid-cols-3 gap-8 border-t border-white pt-8">
              <div>
                <h3 className="text-4xl md:text-5xl font-black mb-2 text-white">500+</h3>
                <p className="text-xs font-sans uppercase tracking-widest text-gray-400">Members</p>
              </div>
              <div>
                <h3 className="text-4xl md:text-5xl font-black mb-2 text-white">100+</h3>
                <p className="text-xs font-sans uppercase tracking-widest text-gray-400">Legal Programs</p>
              </div>
              <div>
                <h3 className="text-4xl md:text-5xl font-black mb-2 text-white">50+</h3>
                <p className="text-xs font-sans uppercase tracking-widest text-gray-400">Community Events</p>
              </div>
            </div>
          </div>

          {/* Right Content - Founder Card */}
          <div className="flex justify-center items-center">
            <div className="w-full max-w-sm">
              {/* Geometric Frame */}
              <div className="relative">
                {/* Outer White Box */}
                <div className="aspect-square bg-white rounded-lg"></div>
                
                {/* Inner Black Frame with Content */}
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-5/6 h-5/6 rounded-lg border-4 border-black flex flex-col items-center justify-center bg-black p-6">
                    {/* Logo Image or Initials */}
                    <img
                      src={logo}
                      alt="Legal Lions Logo"
                      className="w-24 h-24 rounded-full object-cover border-2 border-white mb-6"
                    />
                    
                    {/* Founder Details */}
                    <h3 className="text-2xl md:text-3xl font-black text-white text-center mb-2">
                      Lion R. Sam Rozer
                    </h3>
                    <p className="text-sm md:text-base font-sans text-gray-300 uppercase tracking-widest text-center mb-3">
                      Founder & President
                    </p>
                    <p className="text-xs md:text-sm font-sans text-gray-400 text-center">
                      Legal Lions People Association
                    </p>
                  </div>
                </div>
              </div>

              {/* Caption with Left Border */}
              <div className="mt-8 border-l-4 border-white pl-6">
                <p className="text-sm md:text-base font-sans text-gray-300 leading-relaxed">
                  Leading the mission to provide access to justice and legal awareness for all citizens.
                </p>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default Hero;